import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import { useRef } from 'react';
import { block } from '../../utils/block.js';
import './Modal.scss.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const _excluded = ["id", "title", "children", "isOpen", "icon", "onClose", "className", "contentClassName"];
const b = block('modal');
const Modal = _ref => {
  let {
      id,
      title,
      children,
      isOpen,
      icon,
      onClose,
      className = '',
      contentClassName = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const headerId = "".concat(id, "_header");
  const bodyId = "".concat(id, "_body");
  const closeButton = useRef(null);

  //for trap focus inside the modal
  const onTransition = e => {
    if (e.propertyName === 'background-color' && e.currentTarget === e.target) {
      var _closeButton$current;
      (_closeButton$current = closeButton.current) === null || _closeButton$current === void 0 ? void 0 : _closeButton$current.focus();
    }
  };
  return /*#__PURE__*/jsx("dialog", _objectSpread2(_objectSpread2({
    className: b({
      open: isOpen
    }).mix(className),
    role: "dialog",
    id: id,
    "aria-labelledby": headerId,
    "aria-describedby": bodyId,
    "aria-modal": "true",
    "aria-hidden": !isOpen,
    "data-open": isOpen,
    onTransitionEnd: onTransition
  }, rest), {}, {
    children: /*#__PURE__*/jsxs("div", {
      className: b('content').mix(contentClassName),
      children: [/*#__PURE__*/jsxs("header", {
        className: b('header'),
        children: [/*#__PURE__*/jsx("h1", {
          className: b('header-title'),
          id: "".concat(id, "_header"),
          children: title
        }), onClose && /*#__PURE__*/jsx("button", {
          "aria-label": "close",
          className: b('close-icon'),
          onClick: onClose,
          disabled: !isOpen,
          ref: closeButton
        })]
      }), /*#__PURE__*/jsxs("div", {
        id: bodyId,
        className: b('body'),
        children: [icon && /*#__PURE__*/jsx("div", {
          className: b('icon'),
          children: icon
        }), children]
      })]
    })
  }));
};

export { Modal };
